import React from 'react';

class ToggleButton extends React.Component {
  render() {
    const { buttonText, selected, onClick, pro = false } = this.props;

    return (
      <div className={`lex-toggle-row${pro ? ' lex-toggle-row--premium' : ''}`}>
        <span className="lex-toggle-row__label">{buttonText}</span>
        <label className="lex-toggle">
          <input
            type="checkbox"
            className="lex-toggle__input"
            checked={selected}
            onChange={() => onClick()}
          />
          <span className={`lex-toggle__track${selected ? ' lex-toggle__track--on' : ''}`} />
        </label>
      </div>
    );
  }
}

export default ToggleButton;
